import { render, staticRenderFns } from "./UserEditTabAccount.vue?vue&type=template&id=1d657d25&scoped=true"
import script from "./UserEditTabAccount.vue?vue&type=script&lang=js"
export * from "./UserEditTabAccount.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabAccount.vue?vue&type=style&index=0&id=1d657d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d657d25",
  null
  
)

export default component.exports